import React, { useState } from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { ESGImpactTypes } from 'shared/constants/ESGImpactTypes';

export const ImpactTypeControls = ({ onChange, horizontal, includeTotal }) => {
  const filterImpactTypes = () =>
    Object.values(ESGImpactTypes).filter(value =>
      includeTotal ? value : value !== ESGImpactTypes.TOTAL,
    );

  const [impactTypes] = useState(filterImpactTypes());
  const [value, setValue] = useState(impactTypes[0]);

  const handleChange = ({ target }) => {
    setValue(target.value);
    onChange(target.value);
  };

  return (
    <FormControl component="fieldset">
      <RadioGroup row={horizontal} name="impactType" value={value} onChange={handleChange}>
        {impactTypes.map(impactType => (
          <FormControlLabel
            key={impactType}
            value={impactType}
            control={<Radio color="primary" />}
            label={capitalize(impactType)}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

ImpactTypeControls.defaultProps = {
  horizontal: false,
  includeTotal: true,
};

ImpactTypeControls.propTypes = {
  onChange: PropTypes.func.isRequired,
  horizontal: PropTypes.bool,
  includeTotal: PropTypes.bool,
};
